import { apiSlice } from '../api/apiSlice'

export const tasksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => `/tasks`
    }),

    getTask: builder.query({
      query: (id) => `/tasks/${id}`
    }),

    addTask: builder.mutation({
      query: (data) => ({
        url: '/tasks',
        method: 'POST',
        body: data
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const response = await queryFulfilled;
          if (response?.data && response?.data?.id) {
            dispatch(apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(response?.data)
            }));
          }
        } catch (err) { }
      },
    }),

    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: 'PATCH',
        body: data
      }),
      async onQueryStarted({ id, data }, { queryFulfilled, dispatch }) {
        try {
          const response = await queryFulfilled;
          if (response?.data && response?.data?.id) {
            dispatch(
              apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
                const indexToUpdate = draft.findIndex(task => task.id == id)
                if (indexToUpdate > -1) {
                  draft[indexToUpdate] = response?.data
                }
              })
            );
          }
        } catch (err) { }
      },
    }),

    deleteTask: builder.mutation({
      query: (id) => ({
        url: `/tasks/${id}`,
        method: 'DELETE'
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        console.info(arg)
        const patchResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            return draft.filter(project => project.id != arg)
          })
        )

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo()
        }
      },
    }),
  })
})

export const {
  useGetTasksQuery,
  useAddTaskMutation,
  useEditTaskMutation,
  useGetTaskQuery,
  useDeleteTaskMutation } = tasksApi;

